import {Injectable} from '@angular/core';
import {EntityState, EntityStore, StoreConfig} from '@datorama/akita';
import {News} from './model';

export interface NewsState extends EntityState<News> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'News' })
export class Store extends EntityStore<NewsState> {

  constructor() {
    super();
  }

}
